__turbopack_context__.v({
  "active": "Pagination-module__-4Lima__active",
  "arrow": "Pagination-module__-4Lima__arrow",
  "button": "Pagination-module__-4Lima__button",
  "dots": "Pagination-module__-4Lima__dots",
  "navButton": "Pagination-module__-4Lima__navButton",
  "page": "Pagination-module__-4Lima__page",
  "pages": "Pagination-module__-4Lima__pages",
  "pagination": "Pagination-module__-4Lima__pagination",
});
